/**
 * @typedef {Object} Money
 * @property {number} amount
 * @property {string} currency - EUR, USD, CREDITS...
 */

export default (money, convertToCurrency, exchangeRatesForEur) => {
  if (money.currency === convertToCurrency) {
    return money;
  }

  const k = (1 / exchangeRatesForEur[money.currency]) * exchangeRatesForEur[convertToCurrency];
  return {
    amount: money.amount * k,
    currency: convertToCurrency,
  };
};
